import { instanceApi } from '../../../services';

export const getPartnerPartnerships = (): Promise<any> => instanceApi.get(`api/Dashboard/GetPartnerPartnerships?showExpired=true`);

export const getCashbackReport = (fromDate: string, toDate: string, partnershipCodes: string[]): Promise<any> => {
  const params = new URLSearchParams();
  partnershipCodes.forEach((p) => params.append('PartnershipCodes', p));

  return instanceApi.get(`rebate/report/getclientcashbackcommissionreport?Start=${fromDate}&End=${toDate}${partnershipCodes.length > 0 ? `&${params}` : ``}`);
};
